import Settings from "../Admin/MainDashboard/Reuse/Settings";
import JurySingleCardSchedule from "../Audition_static/Audition_admin/AuditionMainDashboard/Reuse/JurySingleCardSchedule";
import JuryTableCard from "../Audition_static/Audition_admin/AuditionMainDashboard/Screen/JuryTableCard";
import JuryBoardDashboard from "./Dashboard/JuryBoardDashboard";
import LiveAudition from "./Pages/LiveAudition/LiveAudition";
import SingleLiveAuditionVideoAssessment from "./Pages/SingleLiveAuditionVideoAssessment/SingleLiveAuditionVideoAssessment";
import VideoAssessmentAsPrimaryGroup from "./Pages/VideoAssessmentAsPrimaryGroup/VideoAssessmentAsPrimaryGroup";
import JuryProfile from "./Screen/JuryProfile";

const JuryBoardRoute = [
  { path: "/jury-board", exact: true, name: "JuryBoard" },

  {
    path: "/jury-board/dashboard",
    exact: true,
    name: "Dashboard",
    component: JuryBoardDashboard,
  },

  {
    path: "/jury-board/schedule",
    exact: true,
    name: "Dashboard",
    component: JurySingleCardSchedule,
  },

  {
    path: "/jury-board/schedule/single/:id/:type",
    exact: true,
    name: "Dashboard",
    component: JuryTableCard,
  },

  {
    path: "/jury-board/live-audition",
    exact: true,
    name: "Jury-board-live-audition",
    component: LiveAudition,
  },
  {
    path: "/jury-board/live-audition-video-assessment/:slug",
    exact: true,
    name: "singleAuditionVideosAssessment",
    component: SingleLiveAuditionVideoAssessment,
  },
  {
    path: "/jury-board/video-assessment-as-primary-group/:slug",
    exact: true,
    name: "singleAuditionVideosAssessment",
    component: VideoAssessmentAsPrimaryGroup,
  },

  // Profile
  {
    path: "/jury-board/profile",
    exact: true,
    name: "profile",
    component: JuryProfile,
  },

  {
    path: "/jury-board/profile-settings",
    exact: true,
    name: "profile",
    component: Settings,
  },

  // //@FIXME: Audition
  // { path: '/superstar/audition', exact: true, name: 'auditions', component: SuperstarAudition },
  // { path: '/superstar/audition/pending', exact: true, name: 'auditions', component:SuperstarAuditionPending},
  // { path: '/superstar/audition/live', exact: true, name: 'auditions', component:SuperstarAuditionLive},
  // { path: '/superstar/auditions/pending/:id', exact: true, name: 'auditions', component: AuditionsStar },
];

export default JuryBoardRoute;
